import { render, staticRenderFns } from "./DutyHandelList.vue?vue&type=template&id=2668f3dc&scoped=true"
import script from "./DutyHandelList.vue?vue&type=script&lang=js"
export * from "./DutyHandelList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2668f3dc",
  null
  
)

export default component.exports